export const APP_NAME = 'Rapid First Look'
export const OPERATOR_NAME = 'Simone Cammarasana'
export const TERMS_VERSION = '2026-07-15-v2'
export const MAX_UPLOAD_BYTES = 20 * 1024 * 1024
export const MAX_UPLOAD_LABEL = '20 MB'
export const READING_TIME_LABEL = 'about 15 minutes'
export const CONTACT_EMAIL =
  import.meta.env.VITE_CONTACT_EMAIL || 'contact-email-not-configured@example.com'

export const ACTIVE_STATUSES = ['queued', 'in_progress'] as const
